import { resetPasswordComponent } from './reset-password.component';

export const resetPassword = angular
	.module('components.auth.resetPassword', [])
    .component('resetPassword',resetPasswordComponent)
    .config(($stateProvider, $urlRouterProvider) => {
		'ngInject';

		$stateProvider
			.state('resetPassword', {
				url: '/password/reset/:token',
				component : 'resetPassword',
				resolve: {
					isTokenValid($stateParams, AuthService, $state) {
						'ngInject';
						
						return AuthService.confirmToken(decodeURIComponent($stateParams.token))
							.then(details => {
								return details.isExpire === false ? true : false;
							})
							.catch((error) => {
							if(error.status === 401){
								$state.go('password',{token : $stateParams.token});
							}
							return true;
						});
					},
					token($stateParams) {
						'ngInject';

						return decodeURIComponent($stateParams.token);
					}
				}
			});
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/components/auth/reset-password/reset-password.module.js